import { getPreferDesktop, isMobileUserAgent } from "./device";

import { hasPermission } from "./permissionStore";



/** 登录后、访问 / 或 /dashboard 时：移动设备且具备任一 H5 查看权限 → H5 首页，否则 PC 首页 */

export function defaultHomePath() {

  if (getPreferDesktop()) {

    return "/dashboard";

  }

  if (

    isMobileUserAgent() &&

    (hasPermission("h5:mp-order:view") || hasPermission("h5:onboarding:view"))

  ) {

    return "/h5/home";

  }

  return "/dashboard";

}

